export default __webpack_public_path__ + "static/media/Italian-enthusiast.87507255.png";